module.exports = __webpack_public_path__ + "img/avatar-lindsey-wallace.229d8bb7.jpg";